const BASE = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5000`;

const getToken = () => localStorage.getItem("kd_token") || sessionStorage.getItem("kd_token");

export const api = async (endpoint, { method = "GET", body, auth = true } = {}) => {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  const url = `${BASE.replace(/\/+$/, "")}${endpoint}`;
  const res = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  
  let data;
  try {
    const text = await res.text();
    data = text ? JSON.parse(text) : {};
  } catch (err) {
    throw new Error(`Server returned invalid response (Status: ${res.status}). URL: ${url}`);
  }

  if (!res.ok) throw Object.assign(new Error(data.error || `Error ${res.status}`), data);
  return data;
};

export const storeToken = (token, remember = true) => {
  clearToken(); // Always clear previous to avoid conflicts
  if (remember) {
    localStorage.setItem("kd_token", token);
  } else {
    sessionStorage.setItem("kd_token", token);
  }
};

export const clearToken = () => {
  localStorage.removeItem("kd_token");
  sessionStorage.removeItem("kd_token");
};

export const hasToken = () => {
  return !!localStorage.getItem("kd_token") || !!sessionStorage.getItem("kd_token");
};
